module.exports = __webpack_public_path__ + "static/media/threatDetailTitle.b585b79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/threatDetailTitle.png
// module id = 1507
// module chunks = 0